exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div#htmldef>p>ul{list-style:disc!important;margin:0;padding-left:1.25rem}div#htmldef>p>ol{list-style:auto!important;margin:0;padding-left:1.25rem}", ""]);

// exports
